/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="3"
        height="18"
        viewBox="0 0 3 18"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M1.5 15A1.5 1.5 0 1 1 0 16.5 1.5 1.5 0 0 1 1.5 15Zm0-15a1 1 0 0 1 1 1v10a1 1 0 0 1-2 0V1a1 1 0 0 1 1-1Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'ExclamationPointIcon';

export default Icon;
